import { useUserContext } from "@/providers";
import { faMask } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Alert, Button } from "antd";
import { func } from "prop-types";
import { FormattedMessage, useIntl } from "react-intl";

const ImpersonationAlert = ({ onCancelClick }) => {
  const {
    userDisplayName,
    isImpersonating,
    resetImpersonation,
    isUserTokenLoading,
  } = useUserContext();

  const intl = useIntl();

  if (!isImpersonating) return null;

  const cancelClicked = () => {
    resetImpersonation();
    onCancelClick?.();
  };

  return (
    <Alert
      message={
        <FormattedMessage
          id="profile.impersonationAlert"
          values={{ displayName: userDisplayName }}
        />
      }
      type="info"
      showIcon={true}
      icon={<FontAwesomeIcon icon={faMask} />}
      action={
        <Button
          data-test-id="impersonation-alert-cancel"
          onClick={cancelClicked}
          loading={isUserTokenLoading}
        >
          {intl.formatMessage({ id: "general.cancel" })}
        </Button>
      }
    />
  );
};

ImpersonationAlert.propTypes = {
  onCancelClick: func,
};

export default ImpersonationAlert;
